import DASHBOARD_API from "./dashboards";
import DOCUMENTS_API from "./documents";
import FUND_API from "./fund";
import HOLIDAYS_API from "./holidays";
import INSTRUMENT_API from "./instrument";
import LEGALENTITY_API from "./legalEntity";
import MARKETDATA_API from "./marketdata";
import OEMS_API from "./oems";
import PORTFOLIO_API from "./portfolios";
import REPORTS_API from "./reports";
import SECURITY_API from "./security";
import STORAGE_API from "./storage";
import USER_API from "./user";
import UTILITY_API from "./utility";
import WATCHLIST_API from "./watchList";
export const REST_API = (restServer) => ({
    DASHBOARD: DASHBOARD_API(restServer),
    DOCUMENTS: DOCUMENTS_API(restServer),
    FUND: FUND_API(restServer),
    INSTRUMENT: INSTRUMENT_API(restServer),
    LEGALENTITY: LEGALENTITY_API(restServer),
    OEMS: OEMS_API(restServer),
    PORTFOLIO: PORTFOLIO_API(restServer),
    REPORTS: REPORTS_API(restServer),
    SECURITY: SECURITY_API(restServer),
    STORAGE: STORAGE_API(restServer),
    USER: USER_API(restServer),
    UTILITY: UTILITY_API(restServer),
    WATCHLIST: WATCHLIST_API(restServer),
    HOLIDAYS: HOLIDAYS_API(restServer),
    MARKETDATA: MARKETDATA_API(restServer),
});
export * from "./utils/documents";
